import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { collection, getDocs } from "firebase/firestore";
import { app, db } from "../firebase";

function ProtectedAdminRoute({ children }) {
  const auth = getAuth(app);

  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      const user = auth.currentUser;

      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const snapshot = await getDocs(collection(db, "admins"));

        let found = false;

        snapshot.forEach((doc) => {
          const data = doc.data();

          if (
            data.email &&
            data.email.toLowerCase() === user.email.toLowerCase() &&
            data.role === "admin"
          ) {
            found = true;
          }
        });

        setIsAdmin(found);
      } catch (error) {
        console.error(error);
      }

      setLoading(false);
    };

    checkAdmin();
  }, [auth]);

  if (loading) {
    return <h2 style={{ textAlign: "center" }}>Checking access...</h2>;
  }

  if (!isAdmin) {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
}

export default ProtectedAdminRoute;